<template>
    <NevsCard class="login-card">
        <div class="logo-container">
            <img :src="logo"/>
        </div>
        <template v-if="mode==='login'">
            <NevsTextField v-model="loginData.email" :label="$LANG.Get('fields.email')+':'" :name="'email'"
                           :width="'100%'"></NevsTextField>
            <NevsTextField v-model="loginData.password" :label="$LANG.Get('fields.password')+':'" :name="'password'"
                           :type="'password'" :width="'100%'"
                           @keyup.enter="loginClick()"></NevsTextField>
            <div class="login-card-forgotten-password-button" @click="passwordRecoveryToggle">
                {{ $LANG.Get('labels.forgottenPassword') }}
            </div>
            <NevsCheckbox v-model="loginData.remember" :label="$LANG.Get('labels.rememberLogin')"></NevsCheckbox>
            <div class="login-card-footer">
                <NevsButton class="nevs-float-right" @click="loginClick"><i class="fa-solid fa-right-to-bracket"></i> {{ $LANG.Get('buttons.login') }}</NevsButton>
            </div>
        </template>
        <template v-if="mode==='recovery'">
            <div class="login-card-forgotten-password-explanation">{{
                    $LANG.Get('texts.forgottenPasswordExplanation')
                }}
            </div>
            <NevsTextField v-model="passwordResetData.email" :label="$LANG.Get('fields.email')+':'" :name="'email'"
                           :width="'100%'"
                           class="login-card-forgotten-password-email"></NevsTextField>
            <div class="login-card-footer">
                <NevsButton @click="passwordRecoveryToggle"><i class="fa-solid fa-xmark"></i> {{
                        $LANG.Get('buttons.cancel')
                    }}
                </NevsButton>
                <NevsButton class="login-card-forgotten-password-recovery-button" @click="passwordRecoveryClick"><i class="fa-solid fa-key"></i> {{
                        $LANG.Get('buttons.recoverPassword')
                    }}
                </NevsButton>
            </div>
        </template>
        <div class="nevs-clear-float"></div>
        <div class="login-disclaimer" v-html="$LANG.Get('labels.loginFooter')"></div>
    </NevsCard>
</template>

<script>
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";

export default {
    name: "LoginForm",
    components: {
        NevsCheckbox,
        NevsTextField,
        NevsCard,
        NevsButton
    },
    props: {
        postLogin: {
            type: Function
        }
    },
    data() {
        return {
            logo: import.meta.env.BASE_URL + 'logo.png',
            loginData: {
                email: '',
                password: '',
                remember: false
            },
            passwordResetData: {
                email: ''
            },
            mode: 'login'
        }
    },
    methods: {
        passwordRecoveryClick() {
            let vm = this;
            this.$API.APICall('post', 'public/password-reset', this.passwordResetData, (data, success) => {
                if (success) {
                    vm.passwordRecoveryToggle();
                    vm.$LOCAL_BUS.TriggerEvent('popup', {
                        text: vm.$LANG.Get('alerts.passwordResetSuccessful'),
                        type: 'alert'
                    });
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        passwordRecoveryToggle() {
            this.mode = (this.mode === 'login') ? 'recovery' : 'login';
            this.passwordResetData = {
                email: ''
            };
            this.loginData = {
                email: '',
                password: '',
                remember: false
            };
        },
        loginClick() {
            let vm = this;
            this.$API.APICall('post', 'public/login', this.loginData, (data, success) => {
                if (success) {
                    // Before setUser, which is what puts the menu on screen: it reads its stored state as it is created.
                    vm.$store.commit('setUserData', data.user_data);
                    vm.$store.commit('setUser', data.user);
                    vm.$store.commit('setLocale', data.user.locale);
                    vm.postLogin();
                    vm.$CROSS_TAB_BUS.TriggerEvent('check-messages', {});
                } else {
                    if (data !== undefined && data.error !== undefined) {
                        if (data.error === 'account expired') {
                            vm.$LOCAL_BUS.TriggerEvent('popup', {
                                text: vm.$LANG.Get('alerts.accountExpired'),
                                type: 'alert'
                            });
                        }
                        if (data.error === 'account frozen') {
                            vm.$LOCAL_BUS.TriggerEvent('popup', {
                                text: vm.$LANG.Get('alerts.accountFrozen'),
                                type: 'alert'
                            });
                        }
                        if (data.error === 'account blocked') {
                            // Name the address the notice went to when the client has one; the popup renders
                            // HTML, so it is escaped.
                            let blockedEmail = (data.email || '')
                                .replace(/&/g, '&amp;')
                                .replace(/</g, '&lt;')
                                .replace(/>/g, '&gt;')
                                .replace(/"/g, '&quot;');
                            vm.$LOCAL_BUS.TriggerEvent('popup', {
                                text: blockedEmail !== ''
                                    ? vm.$LANG.Get('alerts.accountBlockedEmail').replace('%email%', blockedEmail)
                                    : vm.$LANG.Get('alerts.accountBlocked'),
                                type: 'alert'
                            });
                        }
                        if (data.error === 'login failed') {
                            vm.$LOCAL_BUS.TriggerEvent('popup', {
                                text: vm.$LANG.Get('alerts.loginFailed'),
                                type: 'alert'
                            });
                        }
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                        vm.$LOCAL_BUS.TriggerEvent('popup', {
                            text: vm.$LANG.Get('alerts.loginFailed'),
                            type: 'alert'
                        });
                    }
                }
            });
        }
    }
}
</script>

<style scoped>
.logo-container {
    text-align: center;
    border-bottom: 1px dotted #5e6278;
    margin-bottom: 10px;
}

.logo-container img {
    width: 100%;
    max-width: 250px;
}

.login-disclaimer {
    text-align: center;
    margin-top: 20px;
    border-top: 1px dotted #5e6278;
    padding-top: 5px;
}

</style>